import { hasQuery } from './../../../../common/utils/event-typeguards';
import { GenericValue } from 'hisng';
import { Directive, OnInit } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Directive()
export abstract class WithSuggestionsComponent<T extends GenericValue> extends AbstractFieldComponent<T> implements OnInit {
    suggestions: T[] = [];
    unfiltered: T[] = [];

    fillSuggestions( event: unknown ): void {
        if ( hasQuery( event ) ) {
            this.suggestions = this.filterSuggestions( event.query );
        }
    }

    abstract ngOnInit(): void;

    private filterSuggestions( query: string ): T[] {
        return this.unfiltered.filter( v => v.text.toLowerCase().search( query.toLowerCase() ) !== -1 );
    }
}
